import { useFormikContext } from 'formik'
import { useCallback, useEffect, useMemo } from 'react'
import { LocAndSvcsFormModel } from '../../formConfig'
import type { CheckboxOption, CheckedHandler } from '../../typings'

type Props = {
  serviceOptions: CheckboxOption[]
}

export function useSplitServices(props: Props) {
  const { serviceOptions } = props

  const { setValues, setFieldValue } = useFormikContext<LocAndSvcsFormModel>()

  const onChangeRadio = useCallback<CheckedHandler>(
    (e) => {
      const serviceType = e.target.value as LocAndSvcsFormModel['serviceType']

      setValues((v) => ({
        ...v,
        serviceType,
        serviceIds: new Map(),
      }))
    },
    [setValues],
  )

  const { oneTime, recurring } = useMemo(
    () => ({
      oneTime: serviceOptions.filter((x) => !x.recurring),
      recurring: serviceOptions.filter((x) => x.recurring),
    }),
    [serviceOptions],
  )

  useEffect(() => {
    if (serviceOptions.length > 0) {
      if (oneTime.length === 0) setFieldValue('serviceType', 'recurring')
      else if (recurring.length === 0) setFieldValue('serviceType', 'oneTime')
    } else {
      setFieldValue('serviceType', null)
    }
  }, [oneTime.length, recurring.length, serviceOptions.length, setFieldValue])

  const hasOneTime = oneTime.length > 0
  const hasRecurring = recurring.length > 0

  return {
    oneTime,
    recurring,
    hasOneTime,
    hasRecurring,
    onChangeRadio,
  }
}
